import type { DriveUnitPortOccupancy } from '../redux/ApplicationSlice';
import { buildDriveUnitPortOccupanciesFromProjectCode } from './buildDriveUnitPortOccupanciesFromHardwareCards';
import { buildPersistableDashboardContext, type PersistableDashboardContext } from './dashboardWidgetUtils';

/** Resolves drive-unit ports from live registry state or the project's program text. */
export function resolveDriveUnitPortsForPersistableProject(
  projectCode: string,
  driveUnitPorts: DriveUnitPortOccupancy[] = []
): DriveUnitPortOccupancy[] {
  if (driveUnitPorts.length > 0) return driveUnitPorts;
  return buildDriveUnitPortOccupanciesFromProjectCode(projectCode);
}

/** Persistence context for export/duplicate using a project's stored program code. */
export function buildPersistableDashboardContextForProject(
  project: { program?: { code?: string } },
  driveUnitPorts: DriveUnitPortOccupancy[] = []
): PersistableDashboardContext | undefined {
  const projectCode = project.program?.code ?? '';
  const ports = resolveDriveUnitPortsForPersistableProject(projectCode, driveUnitPorts);
  return buildPersistableDashboardContext(ports, projectCode);
}
